export const removeDuplicateOptions = (options) => {
  let finalOptions = [];

  for (let index = 0; index < options.length; index++) {
    if (!finalOptions.some(o => o.code === options[index].code)) finalOptions.push(options[index])
  }

  return finalOptions
}